var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import axios from "axios";
import humps from "humps";
import { getAuthToken, setAuthToken } from "../../helpers";
import jwt_decode from "jwt-decode";
import { ssoApi } from "../adapters/ssoApi";
// refresh token if its within time
export var refreshTokenIfExpired = function () {
    var token = getAuthToken();
    try {
        if (token) {
            var decodedJWT = jwt_decode(token);
            var nowInSeconds_1 = Math.floor(Date.now() / 1000);
            var exp_1 = decodedJWT.exp, refresh_token_1 = decodedJWT.refresh_token;
            return new Promise(function (resolve, reject) {
                if (nowInSeconds_1 > exp_1) {
                    ssoApi
                        .post("/auth/refresh-token/", {
                        token: refresh_token_1,
                    })
                        .then(function (response) {
                        var _a = response.data, accessToken = _a.accessToken, access_token = _a.access_token;
                        // Temp fix. Axios transform sometimes does not work. This ensures
                        // the property that has a string value is used.
                        var tokenValue = accessToken || access_token;
                        setAuthToken({ value: tokenValue });
                        resolve(tokenValue);
                    })
                        .catch(function () {
                        reject({ message: "invalid token" });
                    });
                }
                else {
                    resolve(token);
                }
            });
        }
        return null;
    }
    catch (_a) {
        return null;
    }
};
/**
 * converts my_var to myVar and back for requests/responses.
 * Covers any and all responses/requests. no type needed
 */
/* istanbul ignore next */
export var sharedAxiosConfiguration = {
    transformRequest: __spreadArray([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
        function (data) { return humps.decamelizeKeys(data); }
    ], __read(axios.defaults.transformRequest), false),
    transformResponse: __spreadArray(__spreadArray([], __read(axios.defaults.transformResponse), false), [
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
        function (data) { return humps.camelizeKeys(data); },
    ], false),
};
